import { instanceApi } from './api'

export const obterDadosAssociado = () => instanceApi.get( '/v1/home' )

export const obterHomeBookster = () => instanceApi.get( '/v1/home/bookster' )
